<template>
  <v-app-bar app>
    <v-breadcrumbs :items="['Learning']" />
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
